/**
 * "v-click-outside" directive
 * Used on a component, if you click outside of it, it will trigger the function used as value
 */
import Vue from 'vue';

Vue.directive('click-outside', {
  bind: function(el, binding, vnode) {
    el.clickOutsideEvent = function(event) {
      // Check if the click was outside the el and his childrens
      if (!el.contains(event.target)) {
        // Call method provided in attribute value
        vnode.context[binding.expression](event, el);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent);
  },
  unbind: function(el) {
    document.body.removeEventListener('click', el.clickOutsideEvent);
  }
});
